import { GET_AGENT_LIST } from '../../endpoints';
import { IAgent } from '../../types/agent';
import makeAuthenticatedRequest from '../base-api';

interface BreakTime {
  startTime: string;
  endTime: string;
}

interface Shift {
  startTime: string;
  endTime: string;
  breakTime: BreakTime[];
}

interface WeeklySchedule {
  day:
    | 'monday'
    | 'tuesday'
    | 'wednesday'
    | 'thursday'
    | 'friday'
    | 'saturday'
    | 'sunday';
  shifts: Shift[];
  isWorkingDay: boolean;
}

interface ShiftSchedule {
  brandId: string;
  weeklySchedule: WeeklySchedule[];
  timezone: string;
}

interface PhoneNumber {
  countryCode?: string;
  number?: string;
  countryCodeEnum?: string;
}

interface HourlyRate {
  brandId: string;
  currency: string;
  amount: number;
}

interface Language {
  language: string;
  fluency: Array<'spoken' | 'written'>;
}

type AgentStatus = 'active' | 'inactive' | 'on_leave' | 'terminated';

const agentListQueryKey = ['agent-list'];

const getAgentList = async (): Promise<{
  success: boolean;
  agents?: IAgent[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_AGENT_LIST);
    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export {
  getAgentList,
  agentListQueryKey,
  type AgentStatus,
  type BreakTime,
  type HourlyRate,
  type Language,
  type PhoneNumber,
  type Shift,
  type ShiftSchedule,
  type WeeklySchedule,
};
